import React from 'react';
import {ReactSVG} from "react-svg";
import LogoSVG from '../../assets/images/logo/postcode-api.svg';

export const Logo = () => {
  return (
    <ReactSVG src={LogoSVG} className="logo" />
  );
}
